import styled from 'styled-components/macro'
import { ifProp } from 'styled-tools'

const Wrapper = styled.div`
  position: relative;
  display: ${ifProp('full', 'block', 'inline-block')};
`

export default Wrapper
